import axios from 'axios';

export class BlobUpload {
  constructor(blob) {
    this.blob = blob;
    this.file = blob.file;

    const { url } = blob.directUploadData;

    this.url = url;
  }

  create(callback) {
    this.callback = callback;

    var formData = new FormData();
    formData.append('file', this.file);

    axios.post(this.url, formData).then(response => {
      this.requestDidLoad(response);
    }).catch(error => {
      this.requestDidError(error);
    });
  }

  requestDidLoad(response) {
    const { status, data } = response;
    if (status >= 200 && status < 300) {
      this.callback(null, data);
    } else {
      this.requestDidError(response);
    }
  }

  requestDidError(response) {
    this.callback(`Error storing "${this.file.name}". Status: ${response.response.status}`);
  }
}
